import React from 'react'
import PropTypes from 'prop-types'

import { Row } from '../../v2/Grid'
import { Text } from '../Text'

const PageTitle = ({ title, children, ...props }) => {
  const isTitleChildren = typeof title !== 'string'

  return (
    <Row bg='white' justifyContent='center'>
      <Row as='section' px={['17px', '10px']} width={['100%', '1140px']} bg='white' {...props}>
        {isTitleChildren ? (
          children
        ) : (
          <Text variant={['big', 'bigger']} fontWeight='400' textAlign='left' color='secondary'>
            {title}
          </Text>
        )}
      </Row>
    </Row>
  )
}

PageTitle.propTypes = {
  title: PropTypes.string
}

export { PageTitle }
